import { Component } from '@angular/core';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  standalone: true,
  styleUrls: ['./badge.component.scss']
})
export class BadgeComponent {}
